module.exports = __webpack_public_path__ + "img/doricmor.96330ee6.png";